<div
  [className]="imgblock?.className"
  [ngStyle]="{
    display: imgblock.display,
    background: imgblock.background,
    'padding-top': imgblock.paddingTop,
    'padding-bottom': imgblock.paddingBottom,
    'text-align': imgblock.align
  }"
>
  <h3
    *ngIf="imgblock.title"
    [ngStyle]="{
      'margin-bottom:10px; display:block;': true,
      color: imgblock.color ? imgblock.color : color
    }"
  >
    {{ imgblock?.title }}
  </h3>
  <img
    [src]="imgblock?.imgUrl"
    [alt]="imgblock.alt"
    [title]="imgblock?.imgTitle && imgblock?.imgTitle !== '' ? imgblock?.imgTitle : ''"
    [ngStyle]="getMyStyles()"
    [ngClass]="{
      pointer:
        imgblock?.targetUrl && imgblock?.targetUrl !== '' && imgblock?.targetUrl !== 'https://'
    }"
    (click)="openImageUrl(imgblock?.targetUrl)"
    (keyup.enter)="openImageUrl(imgblock?.targetUrl)"
    [tabindex]="imgblock?.targetUrl ? 0 : -1"
  />
</div>
